import React from 'react';
import PropTypes from 'prop-types';

const DesktopArrowIcon = ({ width, height, color, rotate }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14.187 26.139"
    style={{
      transform: `rotate(${rotate}deg)`,
    }}
  >
    <path
      d="M13.973,1.613l.414-.414a.7.7,0,0,0,0-.994L2.933-11.25,14.387-22.7a.7.7,0,0,0,0-.994l-.414-.414a.7.7,0,0,0-.994,0L.613-11.747a.7.7,0,0,0,0,.994L12.979,1.613A.7.7,0,0,0,13.973,1.613Z"
      transform="translate(-0.407 24.319)"
      fill={color}
    />
  </svg>
);

DesktopArrowIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rotate: PropTypes.number,
};

DesktopArrowIcon.defaultProps = {
  color: '#600100',
  width: 10,
  height: 21,
  rotate: 0,
};

export default DesktopArrowIcon;
